import axiosInstance from 'utils/InstanceAxios/InstanceAxios';
import { Types } from '../reducers/emailsParams';
import * as serverRoutes from 'utils/consts/serverRoutes.js';
import { toast } from 'react-toastify';

//Synchronous

//Asynchronous
export const getEmails = (page, limit, query, sort = "") => {
  return (dispatch) => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.EmailsConfig.crud('', { page, limit, query, sort }))
      .then((response) => {
        dispatch({
          type: Types.GET_EMAILS,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err)
      })
  }
}

export const getEmail = (emailId) => {
  return dispatch => {
    dispatch({
      type: Types.SET_LOADING,
    });

    axiosInstance.get(serverRoutes.EmailsConfig.crud(`/${emailId}`))
    .then(response => {
        dispatch({
          type: Types.GET_EMAIL,
          payload: response.data,
        })
      })
      .catch((err) => {
        console.log(err);
        dispatch({
          type: Types.GET_EMAIL,
          payload: null,
        });
      });
  }
}

export const uploadEmailTemplateFile = (file, callback, emailId) => {
  return dispatch => {
      axiosInstance.post(serverRoutes.EmailsConfig.crud(`/uploadTemplate/${emailId}`), file, {
          onUploadProgress: e => {
              const progress = parseInt(Math.round((e.loaded * 100) / e.total));
              if (typeof callback === 'function') {
                callback({ progress });
            }
          }
      })
      .then(response => {
          dispatch({
              type: Types.UPLOAD_EMAILTEMPLATE_FILE,
              payload: {content: response.data.uploadedTemplateFile, connect: true},
          });

          if (typeof callback === 'function') {
            callback({
              uploaded: true,
              id: response.data.uploadedTemplateFile._id,
              // url: response.data.uploadedTemplateFile.url,
              // path: response.data.path,
          });
        }
      })
      .catch(err => {
          console.log(" ERROR in action uploadEmailTemplateFile: " ,err)
          dispatch({
              type: Types.UPLOAD_EMAILTEMPLATE_FILE,
              payload: null,
          });
          callback({
              error: true,
              id: err.response?.data?._id,
          });
      });
  }
}
export const deleteEmailTemplateFile = (fileId, callback) => {
  return dispatch => {
      axiosInstance.delete(serverRoutes.EmailsConfig.crud(`/uploadTemplate/${fileId}`))
      .then(response => {
          dispatch({
              type: Types.DELETE_EMAILTEMPLATE_FILE,
          });
          callback();
      })
      .catch(err => {
          console.log(err);
          callback();
      });
  }
}

export const deleteServerTemplateFile = (emailId, callback) => {
  return dispatch => {
    axiosInstance.delete(serverRoutes.EmailsConfig.crud(`/deleteServerFile/${emailId}`))
      .then(response => {
        dispatch({
          type: Types.DELETE_EMAILTEMPLATE_FILE,
        });
        callback();
      })
      .catch(err => {
        console.log(err);
        callback();
      });
  }
}

export const updateEmailFields = (id, fields, callback) => {
  return (dispatch, getState) => {
    const subject = fields.subject;
    const recipients = fields.recipients;
    axiosInstance.put(serverRoutes.EmailsConfig.put(`/${id}`), {
      subject: subject, 
      recipients: recipients
    })
      .then(response => {
        console.log('Response:', response);
        dispatch({
          type: Types.UPDATE_EMAIL_FIELDS,
          payload: response.data,
        });
        fields.subject ? 
        toast.success('Assunto atualizado com sucesso!', { autoClose: 5000 }) 
        : toast.success('Destinatários atualizados com sucesso!', { autoClose: 5000 });
        callback(true);
      })
      .catch((err) => {
        console.log('Error:', err);
        const message = err.response?.data?.error || err.response?.data || err.message;
        toast.error(`Erro: ${err.response?.data?.error?.message || err.response?.data?.error || err.response?.data }`, { autoClose: 10000 });
        callback(false, message);
        const { emailParams } = getState();
        dispatch({
          type: Types.UPDATE_EMAIL_FIELDS,
          payload: emailParams?.emails,
        });
      })
  }
}

export const updateEmailTemplate = (id, document, callback) => {
  return (dispatch, getState) => {
    axiosInstance.put(serverRoutes.EmailsConfig.crud(`/${id}`), {document})
      .then(response => {
        dispatch({
          type: Types.UPDATE_EMAILS_TEMPLATE,
          payload: response.data,
        });
        callback(true);
      })
      .catch((err) => {
        console.log(err);
        callback(false);
        const { emailParams } = getState();
        dispatch({
          type: Types.UPDATE_EMAILS_TEMPLATE,
          payload: emailParams?.emails,
        });
        toast.error(`Erro: ${err.response?.data?.error?.message || err.response?.data?.error || err.response?.data }`, { autoClose: 10000 });
      })
  }
}

export const downloadTemplateFile = (emailId) => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      axiosInstance.get(serverRoutes.EmailsConfig.crud(`/downloadTemplate/${emailId}`), { responseType: 'blob' })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${emailId}.html`);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
          dispatch({
            type: Types.DOWNLOAD_TEMPLATE_FILE,
          });
          resolve();
        })
        .catch(err => {
          console.error(err);
          reject(err);
        });
    });
  }
}

// export const downloadDefaultTemplateFile = (emailId) => {
//   return dispatch => {
//     axiosInstance.get(serverRoutes.EmailsConfig.crud(`/downloadDefaultTemplate/${emailId}`), { responseType: 'blob' })
//       .then(response => {
//         console.log(response);
//         const url = window.URL.createObjectURL(new Blob([response.data]));
//         const link = document.createElement('a');
//         link.href = url;
//         link.setAttribute('download', `${emailId}.html`);
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);
//         window.URL.revokeObjectURL(url);
//         dispatch({
//           type: Types.DOWNLOAD_TEMPLATE_FILE,
//         });
//         resolve();
//       })
//       .catch(err => {
//         console.error(err);
//         reject(err);
//       });
//   }
// }

// export const getAllEmails = () => {
//   return (dispatch) => {
//     dispatch({
//       type: Types.SET_LOADING,
//     });

//     axiosInstance.get(serverRoutes.EmailsConfig.getAll)
//       .then((response) => {
//         dispatch({
//           type: Types.GET_ALL_EMAILS,
//           payload: response.data,
//         })
//       })
//       .catch((err) => {
//         console.log(err)
//       })
//   }
// }